import angular from 'angular';
import { CSAStockInfoDialogModule } from './csa-stock-info-dialog/csa-stock-info-dialog.module';
import { CSAService } from './csa.service';
export var CSAModule = angular
    .module('app.csa', [
    CSAStockInfoDialogModule
])
    .service('CSAService', CSAService)
    .name;
//# sourceMappingURL=csa.module.js.map